module.exports = __webpack_public_path__ + "img/1db2c49.jpg";